import React from 'react'
import Template from './template'

const Unknow = ({ viewBox }) => (
  <Template viewBox={viewBox}>
    <g>
      <path
        style={{ fill: '#C8BDB8' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <circle style={{ fill: '#FFFFFF' }} cx="18.5" cy="47" r="3" />
      <circle style={{ fill: '#FFFFFF' }} cx="28.5" cy="47" r="3" />
      <circle style={{ fill: '#FFFFFF' }} cx="38.5" cy="47" r="3" />
    </g>
  </Template>
)

export default Unknow



// WEBPACK FOOTER //
// ./src/components/Svg/unknown.js